<div class="main-container mat-typography mat-body">

  <!-- HEADER -->
  <h1>{{ resourceListHeader || "Find Information and Documents"}}</h1>

  <!-- Checkbox Header && Toggle All-->
  <section class="refine-resource-category">

    <section class="left-content">
      <!-- Heading -->
      <div class="checkbox-header">
        <h3>{{ resourceCheckboxRefineHeader || "Searchable Tags" }}</h3>
        <a href="javascript:void(0);" (click)="toggleAllCategories()">{{ allValidCheckboxesChecked ? uncheckAllContent
        || "Uncheck All" : checkAllContent || "Check All" }}</a>
      </div>

      <!-- MARKET/CATEGORIES - Checkboxes -->
      <section class="filters categories">

        @for (cat of resourceCategories$ | async; track cat) {
          @if (cat.value.visible) {
            <div class="checkbox-container">
              <mat-checkbox [checked]="cat.value.checked" [disabled]="cat.value.disabled"
              (change)="toggleSingleCategory(cat.key)">{{parseTagName(cat.value.name)}} </mat-checkbox>
            </div>
          }
        }

      </section>

      <section class="dropdown-list">

        <!-- File Search -->
        <mat-form-field class="search-input">
          <mat-label>
            {{ "Search for a file" }}
          </mat-label>
          <input type="text" matInput [formControl]="tableFilterControls.fileSearch" />

          @if (tableFilterControls.fileSearch.value?.length < 3) {
            <mat-error>
              You must enter at least 3 characters
            </mat-error>
          }
        </mat-form-field>

        <!-- Publish Date Filter -->
        <ng-container matColumnDef="topic-filter">
          <mat-form-field appearance="fill">
            <mat-label>Publish Date</mat-label>
            <mat-select
              [formControl]="tableFilterControls.dateRange"
              (selectionChange)="dropdownFilterChanged($event)"
              >
              @for (dateRange of tableFilterSelectObj.dateRange.options; track dateRange) {
                <mat-option
                  [value]="dateRange.daysMinus"
                >{{dateRange.label}}</mat-option>
              }

            </mat-select>

          </mat-form-field>
        </ng-container>
      </section>

      <!-- DATE - dropdown -->
      <div class="dropdown-list">


      </div>

    </section>

    <section class="right-content">

      <!-- ADDITIONAL FILTERS -->
      <section class="filters additional-filters">

        <!-- TYPE - dropdown -->
        <div class="dropdown-list">

          <!-- Filter -->
          <ng-container matColumnDef="type-filter">
            <mat-form-field appearance="fill">
              <mat-label>Types</mat-label>
              <mat-select
                [formControl]="tableFilterControls.type"
                (selectionChange)="typeFilterChanged($event)"
                multiple
                >
                <mat-select-trigger>
                  {{tableFilterControls.type.value?.length ? parseFilterTag(tableFilterControls.type.value[0]) : ''}}
                  @if (tableFilterControls.type.value?.length > 1) {
                    <span class="example-additional-selection">
                      (+{{tableFilterControls.type.value.length - 1}} {{tableFilterControls.type.value?.length === 2 ?
                      'other' : 'others'}})
                    </span>
                  }
                </mat-select-trigger>
                @for (type of tableFilterSelectObj.type.options; track type) {
                  <mat-option [value]="type">
                    {{parseFilterTag(type)}}
                    @if (typeCounts.has(parseFilterTag(type).toUpperCase())) {
                      <span class="filter-badge">
                        ({{typeCounts.get(parseFilterTag(type).toUpperCase())}})
                      </span>
                    } @else {
                      <span class="filter-badge">
                        (0)
                      </span>
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </ng-container>

        </div>

        <!-- TOPIC - dropdown -->
        <div class="dropdown-list">

          <!-- Filter -->
          <ng-container matColumnDef="topic-filter">
            <mat-form-field appearance="fill">
              <mat-label>Topics</mat-label>
              <mat-select
                [formControl]="tableFilterControls.topic"
                (selectionChange)="dropdownFilterChanged($event)"
                multiple
                >
                <mat-select-trigger>
                  {{tableFilterControls.topic.value?.length ? parseFilterTag(tableFilterControls.topic.value[0]) : ''}}
                  @if (tableFilterControls.topic.value?.length > 1) {
                    <span class="example-additional-selection">
                      (+{{tableFilterControls.topic.value.length - 1}}
                      {{tableFilterControls.topic.value?.length === 2 ? 'other' : 'others'}})
                    </span>
                  }
                </mat-select-trigger>
                @for (topic of tableFilterSelectObj.topic.options; track topic) {
                  <mat-option [value]="topic">
                    {{parseFilterTag(topic)}}
                    @if (topicCounts.has(parseFilterTag(topic).toUpperCase())) {
                      <span class="filter-badge">
                        ({{topicCounts.get(parseFilterTag(topic).toUpperCase())}})
                      </span>
                    } @else {
                      <span class="filter-badge">
                        (0)
                      </span>
                    }
                  </mat-option>
                }
              </mat-select>
              <mat-hint>Select a Type first!</mat-hint>

            </mat-form-field>
          </ng-container>

        </div>

      </section>

    </section>


  </section>

  <!-- Document Table -->
  <div [hidden]="!resourcesDataSource" class="table-container">
    <mat-table mat-table matSort class="mat-elevation-z6" [dataSource]="resourcesDataSource">

      <ng-container matColumnDef="fileName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <p>Document</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let document">
          <a href="javascript:void(0);" class="no-text-decor" (click)="saveDocument(document)">
            @if (document.fileName !== document.title) {
              <span class="bold-title">
                {{document.title}}
              </span>
            }
            @if (document.fileName === document.title) {
              <span class="bold-title">
                {{document.fileName}}
              </span>
            }
          </a>
          @if (showDescriptionConfig && document?.description?.length > 0) {
            <div>
              {{document.description}}
            </div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <p>Type</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let document">
          {{document.type}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastModifiedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <p>Published Date</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let document">
          {{document.lastModifiedDate}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="topic">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <p>Topic</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let document">
          {{document.topic}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let document">
          <a href="javascript:void(0);" class="light-padding" (click)="emailDocument(document)">
            <span class="material-symbols-outlined">email</span>
          </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="download">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let document">
          <a href="javascript:void(0);" class="light-padding" (click)="saveDocument(document)">
            <span class="material-symbols-outlined">save_alt</span>
          </a>
        </mat-cell>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9999">
          No data matching the filter
        </td>
      </tr>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <!-- Paginator -->
    <mat-paginator
      #ResourcesListPaginator
      [length]="resourcesDataSource && resourcesDataSource.data && resourcesDataSource.data.length && totalCount"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]">
    </mat-paginator>


  </div>

</div>